import React, { useEffect, useState } from 'react'
import * as classes from './index.module.css'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import Menu from '@Src/svgs/Menu'
import MenuArrow from '@Src/svgs/MenuArrow'
import XIcon from '@Src/svgs/XIcon'
import Play from '@Src/svgs/Play'
import { useStore, setNavState } from '@UseCase/store'

const Navigation = ({ location }) => {
    const [store, dispatch] = useStore()
    const { navOpenState } = store
    const [openedSubMenus, setOpenedSubMenus] = useState({})

    const toggleClass = navOpenState === 'nav' ? classes.navOpend : classes.nav

    const navigation = [
        {
            url: '/about-us',
            title: 'About Us',
        },
        {
            url: '/our-work',
            title: 'Our Work',
        },
        {
            url: '/services',
            title: 'Services',
            subPages: [
                {
                    url: '/services/commercial-strategy',
                    title: 'Commercial Strategy',
                },
                {
                    url: '/services/market-intelligence',
                    title: 'MARKET INTELLIGENCE',
                    subPages: [
                        {
                            url: '/services/market-intelligence/screenthink',
                            title: 'ScreenThink',
                        },
                        {
                            url: '/services/market-intelligence/3reasons',
                            title: '3 Reasons',
                        },
                    ],
                },
                {
                    url: '/services/audience-insights',
                    title: 'Audience Insights',
                },
                {
                    url: '/services/ux-research',
                    title: 'UX RESEARCH',
                },
                {
                    url: '/services/data-and-analytics',
                    title: 'Data & Analytics',
                },
                {
                    url: '/services/cultural-insights-and-trends',
                    title: 'Cultural Insights & Trends',
                },
            ],
        },
        {
            url: '/culture-and-careers',
            title: 'Culture & Careers',
        },
        {
            url: '/news',
            title: 'NEWS & VIEWS',
        },
        {
            url: '/contact',
            title: 'Contact Us',
        },
    ]

    const setState = () => {
        if (navOpenState === 'nav') {
            setNavState(dispatch, '')
            setOpenedSubMenus({})
        } else {
            setNavState(dispatch, 'nav')
        }
    }

    const toggleSubMenu = (url) => {
        setOpenedSubMenus((prev) => ({
            ...prev,
            [url]: !prev[url],
        }))
    }

    useEffect(() => {
        setNavState(dispatch, '')
        setOpenedSubMenus({})
    }, [location, dispatch])

    return (
        <>
            <button
                className={classes.toggle}
                onClick={setState}
                title="Main menu"
                aria-label="Main menu"
            >
                {navOpenState === 'nav' ? (
                    <XIcon className={`${classes.menuIcon} -translate-x-1 -translate-y-1`} />
                ) : (
                    <Menu className={classes.menuIcon} />
                )}
            </button>

            <nav className={toggleClass}>
                <ul className={classes.linksList}>
                    {navigation.map((item) => {
                        const hasSubPages = item.subPages && item.subPages.length > 0
                        const isSubMenuOpen = !!openedSubMenus[item.url]

                        return (
                            <li
                                className={`${classes.navItem} ${
                                    hasSubPages ? classes.hasSubMenu : ''
                                }`}
                                key={item.url}
                                data-item=""
                            >
                                <div className={classes.navItemHead}>
                                    <Link
                                        to={item.url}
                                        className={classes.link}
                                        title={item.title}
                                        activeClassName={classes.activeLink}
                                        partiallyActive={item.url !== '/'}
                                        aria-haspopup={hasSubPages ? 'true' : undefined}
                                        aria-expanded={hasSubPages ? isSubMenuOpen : undefined}
                                    >
                                        {item.title}
                                    </Link>

                                    {hasSubPages && (
                                        <button
                                            type="button"
                                            className={classes.subMenuToggle}
                                            onClick={() => toggleSubMenu(item.url)}
                                            aria-label={`Toggle ${item.title} submenu`}
                                            aria-expanded={isSubMenuOpen}
                                        >
                                            <MenuArrow
                                                className={`${classes.menuArrow} ${
                                                    isSubMenuOpen ? classes.menuArrowOpen : ''
                                                }`}
                                            />
                                        </button>
                                    )}
                                </div>

                                {hasSubPages && (
                                    <ul
                                        className={`${classes.subMenu} ${
                                            isSubMenuOpen ? classes.subMenuOpen : classes.subMenuClosed
                                        }`}
                                    >
                                        {item.subPages.map((subItem) => {
                                            const hasNestedSub =
                                                subItem.subPages && subItem.subPages.length > 0
                                            const isNestedOpen = !!openedSubMenus[subItem.url]

                                            return (
                                                <li
                                                    className={`${classes.navSubItem} ${
                                                        hasNestedSub ? classes.hasNestedMenu : ''
                                                    }`}
                                                    key={subItem.url}
                                                >
                                                    <div className={classes.nestedItemHead}>
                                                        <Link
                                                            to={subItem.url}
                                                            className={classes.subLink}
                                                            title={subItem.title}
                                                            activeClassName={classes.activeSubLink}
                                                            aria-haspopup={hasNestedSub ? 'true' : undefined}
                                                            aria-expanded={hasNestedSub ? isNestedOpen : undefined}
                                                        >
                                                            {subItem.title}
                                                        </Link>

                                                        {hasNestedSub && (
                                                            <>
                                                            <button
                                                                type="button"
                                                                className={classes.nestedMenuToggle}
                                                                onClick={() => toggleSubMenu(subItem.url)}
                                                                aria-label={`Toggle ${subItem.title} submenu`}
                                                                aria-expanded={isNestedOpen}
                                                            >
                                                                <MenuArrow
                                                                    className={`${classes.menuArrow} ${
                                                                        isNestedOpen ? classes.menuArrowOpen : ''
                                                                    }`}
                                                                />
                                                            </button>
                                                            <Play className={classes.caret}/>
                                                            </>
                                                        )}
                                                    </div>

                                                    {hasNestedSub && (
                                                        <ul
                                                            className={`${classes.nestedSubMenu} ${
                                                                isNestedOpen
                                                                    ? classes.subMenuOpen
                                                                    : classes.subMenuClosed
                                                                }`}
                                                        >
                                                            {subItem.subPages.map((nestedItem) => (
                                                                <li
                                                                    className={classes.nestedSubItem}
                                                                    key={nestedItem.url}
                                                                >
                                                                    <Link
                                                                        to={nestedItem.url}
                                                                        className={classes.nestedSubLink}
                                                                        title={nestedItem.title}
                                                                        activeClassName={classes.activeSubLink}
                                                                    >
                                                                        {nestedItem.title}
                                                                    </Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                )}
                            </li>
                        )
                    })}
                </ul>
            </nav>
        </>
    )
}

Navigation.propTypes = {
    location: PropTypes.object,
}

export default Navigation